import { createGlobalStyle } from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
    :root{
        --colorLabel: ${localStorage.getItem('@Inoveclube:colorLabel') ? `${localStorage.getItem('@Inoveclube:colorLabel')}` : '#FFF'};
        --colorButton: ${localStorage.getItem('@Inoveclube:colorButton') ? `${localStorage.getItem('@Inoveclube:colorButton')}` : '#7A05A7'};
        --colorTransversalBar: ${localStorage.getItem('@Inoveclube:colorTransversalBar') ? `${localStorage.getItem('@Inoveclube:colorTransversalBar')}` : '#7A05A7'}; 
        --colorBorderInput: ${localStorage.getItem('@Inoveclube:colorBorderInput') ? `${localStorage.getItem('@Inoveclube:colorBorderInput')}` : '#7A05A7'};
        --colorShadow: ${localStorage.getItem('@Inoveclube:colorShadow') ? `${localStorage.getItem('@Inoveclube:colorShadow') + '1A'}` : 'rgba(0, 0, 0, 0.1)'};
        --colorButtonBottom: ${localStorage.getItem('@Inoveclube:colorButtonBottom') ? `${localStorage.getItem('@Inoveclube:colorButtonBottom')}` : '#FFF'};
        --colorBgHeader: ${localStorage.getItem('@Inoveclube:colorBgHeader') ? `${localStorage.getItem('@Inoveclube:colorBgHeader')}` : '#7A05A7'};

        --colorBackgroundCardsDashboard: #F0F1F5;
        --colorFontsCardsDashboard: #535354;
        --colorBackgroundSubCardsDashboard: #F5F5F5;

        --mainTheme: #7A05A7;
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        outline: 0;
    }

    html{
        text-rendering: optimizeLegibility;
        @media (max-width: 1080px){
            font-size: 93.75%;

        }

        @media (max-width: 720px){
            font-size: 87.5%;
            
        }
    }

    body {
        -webkit-font-smoothing: antialiased;   
        user-select: none;

        &::-webkit-scrollbar-track {
            background-color: #FFF;
        }

        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-thumb {
            background: #C3C3C3;
            border-radius: 4px;
        }

        scrollbar-width: thin;
        scrollbar-color: #C3C3C3;
        scrollbar-track-color: #FFF;
    }


    body, input, button {
        font-family: 'Ubuntu', sans-serif;
        font-weight: 400;
    }

    button {
        cursor: pointer;
    }

    a {
        color: inherit;
        text-decoration: none;
    }

    [disabled]{
        opacity: 0.6;
        cursor: not-allowed;
    }
`;